module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 109.03180506.png";